<template>
  <div class="header-nav-container">
    <div class="header-fluid">
      <div class="logo" @click="goHome">
        <img class="logo-icon" src="@/assets/images/logo.png" alt="" />
      </div>
      <div class="nav-list">
        <el-menu mode="horizontal">
          <el-submenu index="1">
            <template slot="title">关于我们</template>
            <el-menu-item index="Group">
              <router-link tag="p" :to="{ name: 'Group' }">
                新希望集团
              </router-link>
            </el-menu-item>
            <el-menu-item index="Estate">
              <router-link tag="p" :to="{ name: 'Estate' }">
                新希望地产
              </router-link>
            </el-menu-item>
            <el-menu-item index="Leader">
              <router-link tag="p" :to="{ name: 'Leader' }">
                领导班子
              </router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">产品服务</template>
            <el-submenu index="2-4">
              <template slot="title">住宅</template>
              <el-menu-item index="2-4-1">
                <router-link tag="p" :to="{ name: 'TianXi' }">
                  D10天系
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-4-2">
                <router-link tag="p" :to="{ name: 'JinLinXi' }">
                  锦麟系
                </router-link>
              </el-menu-item>
              <el-menu-item index="2-4-3">
                <router-link tag="p" :to="{ name: 'JinYueXi' }">
                  锦悦系
                </router-link>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="2-1">
              <router-link tag="p" :to="{ name: 'Office' }">
                办公楼
              </router-link>
            </el-menu-item>
            <el-menu-item index="2-2">
              <router-link tag="p" :to="{ name: 'Hotel' }"> 酒店 </router-link>
            </el-menu-item>
            <el-menu-item index="2-3">
              <router-link tag="p" :to="{ name: 'Synthesis' }">
                综合体
              </router-link>
            </el-menu-item>
            <el-menu-item index="2-4">
              <router-link tag="p" :to="{ name: 'Apartment' }">
                长租公寓
              </router-link>
            </el-menu-item>
            <el-menu-item index="2-5">
              <router-link tag="p" :to="{ name: 'TouristTown' }">
                现代文旅
              </router-link>
            </el-menu-item>
            <el-menu-item index="2-6">
              <router-link tag="p" :to="{ name: 'IndustrialPark' }">
                产业园区
              </router-link>
            </el-menu-item>
            <el-menu-item index="2-7">
              <a
                style="
                  text-decoration: none;
                  color: inherit;
                  display: inline-block;
                  width: 100%;
                "
                href="https://www.newhopeservice.com.cn/"
                target="_blank"
              >
                物业服务
              </a>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">希望天地</template>
            <el-menu-item index="3-1">
              <router-link tag="p" :to="{ name: 'Product' }">
                精致产品
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-2">
              <router-link tag="p" :to="{ name: 'Active' }">
                精致活动
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-3">
              <router-link tag="p" :to="{ name: 'Welfare' }">
                新希望公益
              </router-link>
            </el-menu-item>
            <el-menu-item index="3-4">
              <router-link tag="p" :to="{ name: 'Love' }">
                精准扶贫1+1：希望爱行
              </router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">加入我们</template>
            <el-menu-item index="4-1">
              <router-link tag="p" :to="{ name: 'Plan' }">
                百千万人才战略
              </router-link>
            </el-menu-item>
            <el-menu-item index="4-2">
              <router-link tag="p" :to="{ name: 'Strong' }">
                培养发展体系
              </router-link>
            </el-menu-item>
            <el-menu-item index="4-3">
              <router-link tag="p" :to="{ name: 'Job' }">
                社会招聘
              </router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">新闻中心</template>
            <el-menu-item index="5-1">
              <router-link tag="p" :to="{ name: 'GroupNews' }">
                集团新闻
              </router-link>
            </el-menu-item>
            <el-menu-item index="5-2">
              <router-link tag="p" :to="{ name: 'EstateNews' }">
                地产动态
              </router-link>
            </el-menu-item>
            <el-menu-item index="5-3">
              <router-link tag="p" :to="{ name: 'Media' }">
                媒体报道
              </router-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="call" @click="call">400服务热线</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "header-nav",
  data() {
    return {
      activeIndex: null,
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },

    goHome() {
      this.$router.push({
        name: 'Home'
      });
    },

    call() {
      this.$router.push({
        name: 'OkService'
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.header-nav-container {
  background: #3c4346;
  border: none;
  font-size: 14px;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 999;
  position: absolute;
  color: #fff;

  .header-fluid {
    width: 1170px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }

  .logo {
    max-width: 177px;
    padding: 0;
    height: auto;
    flex-shrink: 0;
    margin-right: 20px;
    cursor: pointer;
  }

  .logo-icon {
    max-width: 177px;
    padding: 0;
    height: auto;
    margin: 20px 0;
  }

  .nav-list {
    flex: 1;
  }

  .call {
    width: 120px;
    flex-shrink: 0;
    text-align: right;
    cursor: pointer;
  }

  ::v-deep {
    .el-menu.el-menu--horizontal {
      border: none;
      background-color: #3c4346;
      color: #fff;
    }

    .el-menu--horizontal > .el-submenu .el-submenu__title {
      color: #fff;

      &:hover {
        color: #008048;
      }
    }

    .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
      display: none;
    }

    .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
    .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
      color: #008048 !important;
    }

    .el-menu--horizontal .el-menu .el-menu-item,
    .el-menu--horizontal .el-menu .el-submenu__title {
      color: #909399;
    }

    .el-menu--horizontal > .el-submenu .el-submenu__title {
      border-bottom: none !important;
    }

    .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
      border-bottom: none !important;
    }
  }
}
</style>
